import React, {useEffect, useState} from 'react';
import bg from "../../Assets/img/bg.jpg";
import {Helmet} from "react-helmet";
import axios from "axios";
import BASEURL from "../../Constant";

const GeneralCleanUp = () => {

    const [service_data, set_service_data] = useState({})
    const getServiceData = () => {
        axios.get(BASEURL + '/api/get-service-data/1').then(res => {
            set_service_data(res.data)
        })
    }

    useEffect(()=>{
        getServiceData()
    }, [])

    return (
        <>
            <Helmet>
                <title>General Clean Up | Mega Dumpster Bin Rental - Best Company That Lets You Clean & Remove Trash & Rubbish</title>
            </Helmet>
            <section>
                <div className="container-fluid g-0">
                    <div className="page-banner">
                        <img src={bg} className="img-fluid" alt="About Us"/>
                        <div className="overly"/>
                        <div className="content">
                            <h1 className="display-1 text-white text-uppercase">GENERAL CLEAN UP</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row section-gap">
                        <div className="col-md-6">
                            <img src={service_data.photo} className="img-thumbnail" alt="About US"/>
                        </div>
                        <div className="col-md-6">
                            <h6 className="text-center text-uppercase">WELCOME TO Mega Dumpster Bin Rental</h6>
                            <h5 className="text-center text-uppercase theme-color">About Mega Dumpster Bin Rental</h5>
                            <p className="lead py-5">Awesome! the best company that lets you clean and remove trash and
                                rubbish anywhere LA county you want.
                            </p>
                            <div className="row">
                                <div className="col-4"><h1 className="theme-color display-3">13</h1><p
                                    className="lead">YEARS OF EXPERIENCED</p></div>
                                <div className="col-4"><h1 className="theme-color display-3">2,342</h1><p
                                    className="lead">HAPPY CUSTOMERS</p></div>
                                <div className="col-4"><h1 className="theme-color display-3">30</h1><p
                                    className="lead">AWARD WINNING </p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row section-gap justify-content-center">
                        <div className="col-md-12 text-start">
                            <h4 className="text-uppercase mb-3">GENERAL CLEAN UP</h4>
                            <p className="lead text-justify" dangerouslySetInnerHTML={{__html: service_data.description}} />
                        </div>
                    </div>
                    <div className="section-gap"/>
                </div>
            </section>
        </>

    );
};

export default GeneralCleanUp;
